export default {
  text: '#202020',
  primary: 'lightgrey',
  secondary: 'darkgrey',
  background: '#FFF',
  backgroundSecondary: '#4a4a4a',
  light: '#FFF',
  dark: '#313131'
}
